import React, {useState, useContext, useEffect} from 'react';
import { IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonHeader, IonContent, IonFooter, IonItem } from '@ionic/react';

import './Reservation_EnterBookingInfo_locals.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';


export function ShowRoomPicsModal (props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);
    const [schema, setSchemaName] = useState(authMerchant_objects.schema);


    function closeModalHandler() {

        props.closeModal(false);
    }

    //  alert("In Show Room Pics");
    //  alert(props.data.roomPic1);
    //  alert(props.data.roomPic2);
    //  alert(props.data.roomPic3);
    //  alert(props.data.roomPic4);

    return (
        <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal id='showRoomPics' isOpen={ props.openModal } className="custom-modal_bookRoom">
        <IonHeader>
            <IonGrid className='grid_checkInHeader'>
                        <IonRow>
                            <IonCol> Room ID</IonCol>
                            <IonCol> Price Per Night</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> {props.data.roomID} </IonCol>
                            <IonCol> {props.data.roomSalePrice} </IonCol>
                        </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='public_booking_viewRoomImages'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
                <IonSlide>
                    <IonGrid >
                        <IonRow>
                            <IonCol> 1/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                {/*<IonImg src={props.data.roomPic1}></IonImg>*/}
                                <IonImg src={`/api/image/${props.data.roomPic1}/${props.data.merchantSchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid >
                        <IonRow>
                            <IonCol> 2/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic2}/${props.data.merchantSchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid >
                        <IonRow>
                            <IonCol> 3/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic3}/${props.data.merchantSchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid >
                        <IonRow>
                            <IonCol> 4/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic4}/${props.data.merchantSchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>
        </IonContent>

        <IonFooter class='appFooter'>

            <IonButton className='modal_footer_button_center' onClick={closeModalHandler}> Close </IonButton>

        </IonFooter>

        </IonModal>) : null }
        </React.Fragment>
    )
}